import { Content } from "./content";

export type PickContentValues<T extends Content, TKey extends keyof T["values"]> = Omit<T, "values"> & { values: Pick<T["values"], TKey> };

/** Used to combine values of fields with the same names in two types */
export type MergeTypes<T, U> = {
  [K in keyof T & keyof U]: T[K] | U[K];
};

export * from "./category";
export * from "./content";
export * from "./contentType";
export * from "./value";
export * from "./user";
export * from "./group";
export * from "./route";
export * from "./form";
export * from "./supportFiles";
export * from "./web";
